"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfFacilityInterestCreateDto = instanceOfFacilityInterestCreateDto;
exports.FacilityInterestCreateDtoFromJSON = FacilityInterestCreateDtoFromJSON;
exports.FacilityInterestCreateDtoFromJSONTyped = FacilityInterestCreateDtoFromJSONTyped;
exports.FacilityInterestCreateDtoToJSON = FacilityInterestCreateDtoToJSON;
exports.FacilityInterestCreateDtoToJSONTyped = FacilityInterestCreateDtoToJSONTyped;
const TravelWillingness_1 = require("./TravelWillingness");
const WorkTypePreference_1 = require("./WorkTypePreference");
/**
 * Check if a given object implements the FacilityInterestCreateDto interface.
 */
function instanceOfFacilityInterestCreateDto(value) {
    if (!('facilityId' in value) || value['facilityId'] === undefined)
        return false;
    if (!('nurseProfileId' in value) || value['nurseProfileId'] === undefined)
        return false;
    if (!('workTypePreference' in value) || value['workTypePreference'] === undefined)
        return false;
    if (!('willingToTravel' in value) || value['willingToTravel'] === undefined)
        return false;
    if (!('specialtyCodes' in value) || value['specialtyCodes'] === undefined)
        return false;
    return true;
}
function FacilityInterestCreateDtoFromJSON(json) {
    return FacilityInterestCreateDtoFromJSONTyped(json, false);
}
function FacilityInterestCreateDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'facilityId': json['facilityId'],
        'nurseProfileId': json['nurseProfileId'],
        'workTypePreference': (0, WorkTypePreference_1.WorkTypePreferenceFromJSON)(json['workTypePreference']),
        'willingToTravel': (0, TravelWillingness_1.TravelWillingnessFromJSON)(json['willingToTravel']),
        'specialtyCodes': json['specialtyCodes'],
        'comment': json['comment'] == null ? undefined : json['comment'],
        'startDateComment': json['startDateComment'] == null ? undefined : json['startDateComment'],
    };
}
function FacilityInterestCreateDtoToJSON(json) {
    return FacilityInterestCreateDtoToJSONTyped(json, false);
}
function FacilityInterestCreateDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'facilityId': value['facilityId'],
        'nurseProfileId': value['nurseProfileId'],
        'workTypePreference': (0, WorkTypePreference_1.WorkTypePreferenceToJSON)(value['workTypePreference']),
        'willingToTravel': (0, TravelWillingness_1.TravelWillingnessToJSON)(value['willingToTravel']),
        'specialtyCodes': value['specialtyCodes'],
        'comment': value['comment'],
        'startDateComment': value['startDateComment'],
    };
}
//# sourceMappingURL=FacilityInterestCreateDto.js.map